var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.onPress}},[_c('img',{staticClass:"img",attrs:{"src":require("../../assets/icon_liaoban.png")}}),_c('div',{staticClass:"p_title"},[_vm._v(" 聊伴测试包（点击下载） ")])])}
var staticRenderFns = []

export { render, staticRenderFns }